import React from "react";
import { View, StyleSheet } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtText from "../../../components/NtText";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import NtSectionButton from "../general/NtSectionButton";
import { useNavigation } from "@react-navigation/native";
import routes from "../../../navigation/routes";

function NtHomeNextGenSection(props) {
  const nav = useNavigation();
  return (
    <NtMarketingSectionContainer
      style={styles.container}
      backgroundImage={require("../../../assets/images/marketing/3fd781565b2a95a31e108cb0c86a6c5005c226f2.jpg")}
    >
      <View
        style={{ flex: 1, justifyContent: "center", alignItems: "flex-start" }}
      >
        <NtSectionTitle style={{ textAlign: "left", fontWeight: "300" }}>
          <NtSectionTitle style={{ fontWeight: "900" }}>NEXTGEN</NtSectionTitle>{" "}
          RESIDENTIAL
        </NtSectionTitle>
        <NtSectionTitle
          style={{ marginTop: 6, textAlign: "left", fontWeight: "300" }}
        >
          PHONE{" "}
          <NtSectionTitle style={{ fontWeight: "900" }}>SERVICE</NtSectionTitle>
        </NtSectionTitle>

        <NtSectionDescription
          style={{
            marginTop: 10,
            lineHeight: 15,
          }}
        >
          Your smarter home phone line. Our most{"\n"}powerful solution yet.
        </NtSectionDescription>

        <NtSectionButton
          containerStyle={{ marginTop: 25 }}
          title="LEARN MORE"
          color="white"
          onPress={() => {
            nav.navigate(routes.plans);
          }}
        />
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    height: 600,
  },
});

export default NtHomeNextGenSection;
